import { isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import ProductPrice, { ProductPriceDto } from "./ProductPrice"


class ProductPriceService {
    static httpClient = new HttpClient<ProductPrice, ProductPriceDto>(ProductPrice)

    static async getAllByProductId(productId: string): Promise<ProductPrice[]> {
        const res = await this.httpClient.get(`/products/${productId}/prices`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as ProductPrice[]
    }

    static async CreateMulti(productId: string, payload: object) {
        const res = await this.httpClient.post(`/products/${productId}/batch-prices`, payload)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res 
    }

    static async update(payload: object) {
        const res = await this.httpClient.post("/product-prices",payload)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res
    }
}

export default ProductPriceService


// WEBPACK FOOTER //
// ./src/state/product-price/ProductPriceService.ts